// src/components/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useAuth as useUserAuth } from "./context/UserAuthContext"; // User auth
import { useAuth as useAdminAuth } from "./context/AuthContext"; // Admin auth (rename if needed)

const ProtectedRoute = ({ isAdmin = false }) => {
    const { isAuthenticated: isUserAuthenticated, loading: userLoading } = useUserAuth();
    const { isAdminAuthenticated, loading: adminLoading } = useAdminAuth();

    if (userLoading || adminLoading) return <p>Loading...</p>;

    if (isAdmin) {
        return isAdminAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
    }

    return isUserAuthenticated ? <Outlet /> : <Navigate to="/sign-in" replace />;
};

export default ProtectedRoute;